import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import { FIX_LOCATION } from 'app/constants/hint';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingContractForm({ updateLocation, users, approver }) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'contract_ids',
          role: 'contract',
          title: '合同审批人',
          hint: FIX_LOCATION.contract,
          selectedUsers: approver
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  return {
    users: selectors.getSpaceUsers(state),
    approver: selectors.getTeamRolesOfLocation(state, loc_id, 'contract') || []
  };
}

export default connect(mapStateToProps)(LocationSettingContractForm);
